class RadioItem {
  public static create(value: string, label: string, description?: string, disabled?: boolean) {
    return Object.assign(new RadioItem(), {
      description,
      disabled,
      label,
      value,
    });
  }
  // @ts-expect-error TS2564 - strict migration
  value: string;
  // @ts-expect-error TS2564 - strict migration
  label: string;
  description?: string;
  disabled?: boolean;
}

export default RadioItem;
